import GlobalObject from '../global';
const locale = {
  get: () => {
    const language = GlobalObject.language === 'en' ? 'en' : 'vi';
    return language;
  },
  set: language => {
    GlobalObject.language = language;
  }
};
export default locale;